/**
 * Analytics (CJA) page-name taxonomy for TORT.
 *
 * Follows the same "kporg:en:nat:mykp:<app>:home:<page>" convention used by
 * the other KP internal apps (WFR, UBT) on this shared Adobe Launch property.
 */

export const ANALYTICS_CONFIG = {
  BASE_PAGE_NAME: 'kporg:en:nat:mykp:tort:home',

  PAGES: {
    REQUESTOR_HOME: 'requestor:home',
    REQUESTOR_CREATE: 'requestor:create',
    REQUESTOR_REQUEST_CONFIRMATION: 'requestor:request-confirmation',
    REQUESTOR_EDIT_SUBMITTED: 'requestor:edit-submitted',
    REQUESTOR_CREATE_VACATION_BID: 'requestor:create-vacation-bid',
    REQUESTOR_VACATION_BID: 'requestor:vacation-bid',
    REQUESTOR_STATUS_DETAIL: 'requestor:status-detail',
    APPROVER_HOME: 'approver:home',
    APPROVER_PROCESS: 'approver:process',
    ADMIN_HOME: 'admin:home',
    ADMIN_MANUAL_TIMEOFF: 'admin:manual-timeoff',
    ADMIN_APPROVER_PROXY: 'admin:approver-proxy',
    ADMIN_REQUESTOR_PROXY: 'admin:requestor-proxy',
    ADMIN_FLOAT_PROXY: 'admin:float-proxy',
  },

  EVENTS: {
    FORM_SUBMIT: 'formSubmit',
    FORM_SAVE: 'formSave',
    FORM_ERROR: 'formError',
    BUTTON_CLICK: 'buttonClick',
  },
} as const

/** Prefixes a page key with the shared TORT base page name. */
export const getFullPageName = (pageKey: string): string => {
  return `${ANALYTICS_CONFIG.BASE_PAGE_NAME}:${pageKey}`
}
